
import { BookmarkType } from 'redux/schemas/models/bookmark';
import angular from 'angular';

/* @ngInject */
export function nvLectureVideoMainBody(
  $rootScope,
  $stateParams,
  $state,
  CurrentUserManager,
  DiscussionsManager,
  BookmarkModel,
  $uibModal,
  $window,
  $translate,
  $timeout,
  _,
  $q,
  PostModel,
  AlertMessages,
  CurrentCourseManager,
  TimelinesManager,
  nvUtil,
) {
  return {
    restrict: 'A',
    scope: {
      currentLectureVideoList: '=',
      discussionUpdated: '=?',
      course: '=',
      scrollToLectureComponent: '&?',
      showEdit: '=?',
      viewMode: '=?',
      context: '@',
    },
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const vm = this;
      const myWindow = angular.element($window);

      vm.currentLectureVideo = vm.currentLectureVideoList.currentLectureVideo;
      vm.CurrentCourseManager = CurrentCourseManager;
      let hasNotGottenPoints = !vm.currentLectureVideo.pointsReceived;
      vm.CurrentUserManager = CurrentUserManager;
      vm.DiscussionsManager = DiscussionsManager;
      vm.isTypeAudio = this.currentLectureVideoList.type === 'AudioListLectureComponent';
      vm.offsetStartTime = null;
      vm.autostart = false;

      if (!vm.isTypeAudio) {
        loadVideoDetails();
      }

      function loadVideoDetails() {
        loadQuizDetails();
        loadDiscussionDetails();
      }

      function loadQuizDetails() {
        vm.currentLectureVideo.getQuiz($stateParams.catalogId)
          .then(() => {
            vm.timeCallback(vm.currentLectureVideo.startPlaybackFrom);
          });
      }

      function loadDiscussionDetails() {
        if (vm.currentLectureVideoList.discussionUpdated) {
          vm.currentLectureVideo.post = null;
        }
        if (!vm.currentLectureVideo.post
                && vm.currentLectureVideo.allowsDiscussions
                && vm.currentLectureVideo.topic) {
          /**
           * Setting the discussion title as the title of the topic forum.
           * Otherwise, it will show the video name as the title.
           */
          if (vm.currentLectureVideo.topic?.forum?.title) {
            vm.currentLectureVideo.topic.title = vm.currentLectureVideo.topic.forum.title;
          }

          vm.currentLectureVideo.post = PostModel.normalizePostData(vm.currentLectureVideo.topic, {
            owner: vm.currentLectureVideo.topic.forum,
            catalogId: $stateParams.catalogId,
            lectureVideo: vm.currentLectureVideo,
          });
          if (DiscussionsManager.currentPosts.length === 0) {
            DiscussionsManager.currentPosts.push(vm.currentLectureVideo.post);
          } else {
            const indexOfOldPost = _.findIndex(DiscussionsManager.currentPosts, { id: vm.currentLectureVideo.post.id });
            const oldPost = DiscussionsManager.currentPosts[indexOfOldPost];
            _.extend(oldPost, vm.currentLectureVideo.post);
          }
        } else if (vm.currentLectureVideo.topic && !vm.currentLectureVideo.topic.topicId) {
          vm.currentLectureVideo.topic.topicId = vm.currentLectureVideo.topic.forumId;
        }
      }

      // Some other ways of updating discussion cause a weird jump in the UI unfortunately
      $scope.$watch('vm.discussionUpdated', (newVideoUrl, oldVideoUrl) => {
        if (newVideoUrl !== oldVideoUrl) {
          if (!vm.isTypeAudio) {
            _.extend(vm.currentLectureVideo, _.pick(vm.currentLectureVideoList.currentLectureVideo, 'allowsDiscussions', 'topic', 'post', 'topicId'));
            loadDiscussionDetails();
            vm.currentLectureVideoList.discussionUpdated = false;
          }
        }
      });

      $scope.$watch('vm.currentLectureVideoList.currentLectureVideo', (newLectureVideo, oldLectureVideo) => {
        if (newLectureVideo && vm.currentLectureVideo.id !== newLectureVideo.id) {
          setVideo(newLectureVideo, false);
        }
      });

      // only for embedded
      function setVideo(lectureVideo, autostart = true) {
        vm.currentLectureVideoList.currentLectureVideo = lectureVideo;
        vm.currentLectureVideo = lectureVideo;
        vm.offsetStartTime = null;
        vm.autostart = autostart;
        hasNotGottenPoints = !vm.currentLectureVideo.pointsReceived;
        loadVideoDetails();
      }

      vm.selectLectureVideo = function (lectureVideo) {
        showWarningModalsIfNecessary().then(() => {
          setVideo(lectureVideo);
          if (vm.scrollToLectureComponent) {
            vm.scrollToLectureComponent({ id: vm.currentLectureVideoList.id });
          }
        });
      };

      /* Video Level */
      vm.eventCallback = (event, second, totalLength) => {
        const promise = vm.currentLectureVideo.eventCallback(event, second, totalLength);
        if (promise) {
          promise.then(() => {
            TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, vm.currentLectureVideo.progress);
          });
        }

        if (!CurrentUserManager.isAdmin()) {
          nvUtil.addUserToHeads(CurrentUserManager.user, vm.currentLectureVideo.usersRecentlyStartedWatching);
        }
      };

      vm.timeCallback = function (second) {
        $timeout(() => {
          const question = vm.currentLectureVideo.timeCallback(second);

          if (question) {
            vm.setCurrentQuestion(question);
          }
        });
      };

      vm.endCallback = function () {
        $timeout(() => {
          if (!vm.currentLectureVideo || !vm.currentLectureVideo.quiz || !vm.currentLectureVideo.quiz.currentQuestion) {
            vm.currentLectureVideo.startPlaybackFrom = 0;

            vm.offsetStartTime = null;

            const nextVideo = vm.currentLectureVideoList.getNextVideo();

            if (nextVideo) {
              showWarningModalsIfNecessary().then(() => {
                setVideo(nextVideo);
              });
            } else {
              showPointsModalIfNecessary();
            }
          }
        });
      };

      vm.getOffsetTime = function () {
        if (vm.offsetStartTime != null) {
          return vm.offsetStartTime;
        }
        return vm.currentLectureVideo.startPlaybackFrom;
      };

      /* Video Quiz */
      vm.DISPLAY_STATES = {
        WORK: 'WORK',
        FEEDBACK: 'FEEDBACK',
        ANSWER_KEY: 'ANSWER_KEY',
      };

      function resetQuizView() {
        if (vm.quizForm) {
          vm.quizForm.$setPristine();
        }
      }

      vm.setCurrentQuestion = function (question) {
        vm.currentLectureVideo.quiz.reviewQuestion = null;
        vm.currentLectureVideo.quiz.setCurrentQuestion(question);
        // vm.currentLectureVideo.play(false);

        if (!question.displayState) {
          if (question.currentResponse) {
            vm.viewFeedback();
          } else {
            vm.retry();
          }
        }
      };

      vm.reviewVideo = function () {
        // vm.currentLectureVideo.seekTo(vm.currentLectureVideo.getReviewOffsetTime());
        vm.offsetStartTime = vm.currentLectureVideo.getReviewOffsetTime();
        vm.autostart = true;

        vm.currentLectureVideo.quiz.reviewQuestion = vm.currentLectureVideo.quiz.currentQuestion;
        vm.currentLectureVideo.quiz.resetCurrentQuestion();
      };

      vm.submit = function () {
        let modalInstance;
        const unansweredCountModalDeffered = $q.defer();
        const finalAttemptModalDeffered = $q.defer();
        let modalInstanceCtrl;
        const { currentQuestion } = vm.currentLectureVideo.quiz;
        let showFinalAttemptModal = false;

        /* Submit with blank response */
        if (currentQuestion.isUnAnswered()) {
          // eslint-disable-next-line no-shadow
          modalInstanceCtrl = ['$scope', 'unansweredCount', function ($scope, unansweredCount) {
            $scope.unansweredCount = unansweredCount;
          }];


          modalInstance = openConfirmationModal('quizzes/templates/modal-questions-blank-submit.html', modalInstanceCtrl, { unansweredCount: 1 });
          modalInstance.result.then(() => {
            unansweredCountModalDeffered.resolve();
          }, () => {
            unansweredCountModalDeffered.reject();
          });
        } else {
          unansweredCountModalDeffered.resolve();
        }

        /* Submit final attempt warning */
        if (vm.currentLectureVideo.quiz.graded) {
          if (!currentQuestion.currentResponse && vm.currentLectureVideo.quiz.maximumAttempts === 1) {
            showFinalAttemptModal = true;
          } else if (currentQuestion.currentResponse
                  && currentQuestion.currentResponse.numberOfAttempts + 1 === vm.currentLectureVideo.quiz.maximumAttempts) {
            showFinalAttemptModal = true;
          }
        }

        if (showFinalAttemptModal) {
          unansweredCountModalDeffered.promise.then(() => {
            modalInstance = openConfirmationModal('quizzes/templates/modal-final-attempt.html');
            modalInstance.result.then(() => {
              finalAttemptModalDeffered.resolve();
            }, () => {
              finalAttemptModalDeffered.reject();
            });
          }, () => {
            finalAttemptModalDeffered.reject();
          });
        } else {
          finalAttemptModalDeffered.resolve();
        }

        $q.all([unansweredCountModalDeffered.promise, finalAttemptModalDeffered.promise]).then(() => {
          vm.currentLectureVideo.quiz.gradeQuestion()
            .then(() => {
              vm.viewFeedback();
            }).catch((error) => {
              AlertMessages.error('', 'FORM.ERROR');
            });
        });
      };

      vm.retry = function () {
        resetQuizView();

        vm.currentLectureVideo.quiz.currentQuestion.resetResponse();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.WORK;
      };

      vm.continue = function () {
        resetQuizView();

        // vm.currentLectureVideo.seekTo(vm.currentLectureVideo.quiz.currentQuestion.second);
        vm.offsetStartTime = vm.currentLectureVideo.quiz.currentQuestion.second;
        vm.autostart = true;

        vm.currentLectureVideo.quiz.resetCurrentQuestion();
      };

      vm.viewAnswer = function () {
        resetQuizView();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.ANSWER_KEY;
      };

      vm.viewFeedback = function () {
        resetQuizView();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.FEEDBACK;
      };

      vm.feedbackButtonClasses = function () {
        const classes = [];

        if (vm.currentLectureVideo.quiz.graded) {
          if (!vm.currentLectureVideo.quiz.currentQuestion.currentResponse.isCorrect) {
            if (vm.currentLectureVideo.quiz.currentQuestion.currentResponse.numberOfAttempts
                  < vm.currentLectureVideo.quiz.maximumAttempts) {
              classes.push('double');
              classes.push('with-link');
            } else {
              classes.push('with-double-link');
            }
          }
          // else - just a single continue button
        } else {
          classes.push('double');
          if (!vm.currentLectureVideo.quiz.currentQuestion.currentResponse.isCorrect) {
            classes.push('with-link');
          }
        }

        return classes.join(' ');
      };

      vm.createBookmark = function () {
        BookmarkModel.createBookmark({
          type: vm.isTypeAudio ? BookmarkType.AUDIO : BookmarkType.VIDEO,
          catalogId: $stateParams.catalogId,
          componentId: vm.currentLectureVideo.id,
        })
          .then(bookmark => {
            vm.currentLectureVideo.bookmarkId = bookmark.id;
          });
      };

      vm.highlightBookmark = function () {
        BookmarkModel.highlightBookmark(vm.currentLectureVideo.bookmarkId);
      };

      function showPointsModal(pointModalDeferred) {
        TimelinesManager.updateComponentPointsAndProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id,
          vm.currentLectureVideo.pointsReceived);
        hasNotGottenPoints = false;

        $uibModal.open({
          templateUrl: 'shared/templates/points-modal.html',
          windowClass: 'points-modal',
          controller: 'PointsModalCtrl as vm',
          resolve: {
            pointsReceived: vm.currentLectureVideo.pointsReceived,
            leaderboardPoints: vm.currentLectureVideo.leaderboardPoints,
            leaderboardRank: vm.currentLectureVideo.leaderboardRank,
            priorLeaderboardRank: vm.currentLectureVideo.priorLeaderboardRank,
            extras: null,
          },
        }).result.then((result) => {
          if (pointModalDeferred) {
            pointModalDeferred.resolve();
          }
        }, (result) => {
          if (pointModalDeferred) {
            pointModalDeferred.resolve();
          }
        });
      }

      function showPointsModalIfNecessary(pointModalDeferred?) {
        if (vm.currentLectureVideo.lastEventCallbackPromise) {
          if (vm.currentLectureVideo.progress === 'completed') {
            TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, 'completed');
          } else {
            vm.currentLectureVideo.lastEventCallbackPromise.then((lectureVideo) => {
              if (vm.currentLectureVideo.progress === 'completed') {
                TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, 'completed');
              }
            });
          }
        }

        if (CurrentCourseManager.course?.gamificationEnabled && vm.currentLectureVideo.pointsConfiguration && hasNotGottenPoints) {
          if (vm.currentLectureVideo.newPointsReceived) {
            vm.currentLectureVideo.pointsReceived = vm.currentLectureVideo.newPointsReceived;
            vm.currentLectureVideo.leaderboardPoints = vm.currentLectureVideo.newLeaderboardPoints;
            vm.currentLectureVideo.leaderboardRank = vm.currentLectureVideo.newLeaderboardRank;
            vm.currentLectureVideo.priorLeaderboardRank = vm.currentLectureVideo.newPriorLeaderboardRank;
            showPointsModal(pointModalDeferred);
          } else if (!vm.currentLectureVideo.length
                  || vm.currentLectureVideo.startPlaybackFrom / vm.currentLectureVideo.length >= vm.currentLectureVideo.pointsConfiguration.threshold) {
            if (vm.currentLectureVideo.lastEventCallbackPromise) {
              vm.currentLectureVideo.lastEventCallbackPromise.then((lectureVideo) => {
                if (vm.currentLectureVideo.newPointsReceived) {
                  vm.currentLectureVideo.pointsReceived = vm.currentLectureVideo.newPointsReceived;
                  vm.currentLectureVideo.leaderboardPoints = vm.currentLectureVideo.newLeaderboardPoints;
                  vm.currentLectureVideo.leaderboardRank = vm.currentLectureVideo.newLeaderboardRank;
                  vm.currentLectureVideo.priorLeaderboardRank = vm.currentLectureVideo.newPriorLeaderboardRank;
                  showPointsModal(pointModalDeferred);
                } else if (pointModalDeferred) {
                  pointModalDeferred.resolve();
                }
              });
            } else {
              pointModalDeferred.resolve();
            }
          }
        } else if (pointModalDeferred) {
          pointModalDeferred.resolve();
        }
      }

      function showWarningModalsIfNecessary() {
        let modalInstance;
        const pointModalDeferred = $q.defer();
        const dirtyQuizDeferred = $q.defer();

        vm.currentLectureVideo.play(false);

        showPointsModalIfNecessary(pointModalDeferred);

        pointModalDeferred.promise.then(() => {
          if (vm.quizForm?.$dirty) {
            modalInstance = openConfirmationModal('shared/templates/modal-navigate-away.html');
            modalInstance.result.then(() => {
              dirtyQuizDeferred.resolve();
            }, () => {
              dirtyQuizDeferred.reject();
            });
          } else {
            dirtyQuizDeferred.resolve();
          }
        });

        return $q.all([pointModalDeferred.promise, dirtyQuizDeferred.promise]);
      }

      /* Warning when you navigate away with unsaved changes */
      $rootScope.$on('$stateChangeStartWithPromiseReplacement', (event, toState, toParams, fromState, fromParams, setResolvePromise) => {
        if (vm.viewMode) {
          setResolvePromise(showWarningModalsIfNecessary());
        }
      });

      /** Whether the title for the current video quiz is using the default values of 'Question' or 'Quiz' */
      vm.quizTitleIsDefault = function () {
        return vm.currentLectureVideo.quiz.title === 'Question' || vm.currentLectureVideo.quiz.title === 'Quiz';
      };

      myWindow.on('beforeunload', (e) => {
        let msg;

        if (vm.quizForm?.$dirty) {
          msg = 'FORM.UNSAVED_CHANGES.NAVIGATE_AWAY';

          ((e || window.event) as any).returnValue = msg; // Gecko + IE
          return msg; // Webkit, Safari, Chrome etc.
        }

        // Prevent a confirm dialog form appearing
        return undefined;
      });

      $scope.$on('$destroy', () => {
        vm.deregisterStateChangeStart?.();

        DiscussionsManager.unsubscribeFromPusherEvents();
        DiscussionsManager.resetSearchParams();
      });

      $scope.$on('slideEnded', () => {
        vm.quizForm.$setDirty();
      });

      /** Private Helpers * */
      function openConfirmationModal(templateUrl, modalInstanceCtrl?, data?) {
        return $uibModal.open({
          backdropClass: 'modal-overlay-backdrop',
          controller: modalInstanceCtrl,
          controlleras: 'vm',
          templateUrl,
          windowClass: 'modal-overlay',
          resolve: data,
        });
      }
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'lecture_videos/templates/nv-lecture-video-main-body.html',
  };
}

/* @ngInject */
export function LectureVideoModalInstanceCtrl(
  $scope,
  $uibModalInstance,
  lectureVideo,
) {
  const vm = this;

  vm.lectureVideo = lectureVideo;
}
